import {
    chakra, Flex, Image, Button
} from '@chakra-ui/react';

export const MenuButtonWrapper = chakra(Button, {
    label: 'MenuButtonWrapper',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        position: 'relative',
        border: '1px solid',
        borderColor: 'primary.300',
        borderRadius: '20px',
        minW: 'fit-content',
        h: '40px',
        p: '6px 12px',
        _hover: {
            color: 'primary.600',
            borderColor: 'primary.400',
            backgroundColor: 'primary.50'
        }
    }
});

export const NotificationsCount = chakra(Flex, {
    label: 'UserMenu-NotificationsCount',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'center',
        width: '15px',
        height: '15px',
        borderRadius: '10px',
        color: '#fff',
        backgroundColor: 'error.600',
        fontSize: '10px',
        position: 'absolute',
        right: '-3px',
        top: '-5px',
        pt: '1px'
    }
});

export const ProfileImage = chakra(Image, {
    label: 'ProfileImage',
    baseStyle: {
        display: 'flex',
        h: '28px',
        minWidth: '28px',
        pl: '8px'
    }
});

export const ProfileTitle = chakra(Flex, {
    label: 'MenuProfileTitle',
    baseStyle: {
        alignItems: 'center',
        color: 'primary.700',
        fontSize: '16px',
        fontWeight: 500,
        letterSpacing: '-0.2px',
        pl: '10px'
    }
});

export const getMenuButtonActiveStyles = (isOpen: boolean) => {
    const activeStyles = {
        backgroundColor: 'primary.100',
        border: '1px solid',
        borderColor: 'primary.400',
        color: 'primary.700'
    };

    if (isOpen) {
        return {
            ...activeStyles,
            _hover: activeStyles
        };
    }
};
